import Clipboard from "clipboard";
import env from '../../../../../../../../env.json';

export default class AlLandingpageGeneralComponentController {

    constructor($scope, $http, $injector, Alert) {
        this.scope = $scope;
        this.injector = $injector;
        this.http = $http;
        this.alert = Alert;
        this.translate = this.injector.get('$translate');
        this.users = this.injector.get('Users');
        this.api = this.injector.get('$http');
        this.lodash = _;

        this.generic_url = null;
        this.studio_url = null;

        this.guestlist = null;
        this.guestlist_domain = '';
        this.guestlist_path = '';

        this.studioPageAvailable = false;

        this.userStore = this.injector.get('Users');
        this.studioEnabled = _.get(this.userStore, 'state.company.settings.lp-api.studio_used', false);

        this._initWatchers();
        this._initDomainMode();

        const clipboard = new Clipboard('.clipboard');

        clipboard.on('success', (e) => {
            this.message = 'Link successfully copied';
        });

        clipboard.on('error', (e) => {
            this.message = 'Link has not been copied, try again!';
        });
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.guestlist;
        }, () => {
            if (this.guestlist) {
                this._loadGenericUrl();
                this._loadGuestlistUrl();
                if (this.studioEnabled) {
                    this._checkIfStudioPageIsAvailable();
                }
            }
        }, true);
    }

    openUrl(url) {
        window.open(url, '_blank');
    }

    storeUrl() {
        this._storeGuestlistUrl(this.guestlist_domain, this.guestlist_path);
    }

    /* Private functions */
    _checkIfStudioPageIsAvailable() {
        const promises = [];
        this.studioPageAvailable = false;

        _.each(_.get(this.userStore, 'state.company.settings.guestlist.studio_urls', []), (studio) => {
            promises.push(new Promise((resolve) => {
                    this.api.get(env.studioBackendUrl.concat(`/sites/by-guestlist/${this.guestlist.id}`))
                        .then((response) => {
                            this.studioPageAvailable = true;
                            this._initDomainMode();
                            resolve();
                        })
                        .catch(() => {
                            resolve();
                        })
                })
            )
        });

        return Promise.all(promises)
            .then(() => {
                console.log('resolved');
                if (!this.studioPageAvailable) {
                    this._initDomainMode();
                }
            })
    }

    _loadGenericUrl() {
        let baseUrl = _.get(this.users.state.company, 'settings.lp-api.ext_reg_domain');

        if (baseUrl && baseUrl.match(/GUESTLIST_UID/)) {
            this.generic_url = baseUrl.replace('GUESTLIST_UID', this.guestlist.uid);
        } else {
            this.generic_url = baseUrl + this.guestlist.uid;
        }
    }

    _storeGuestlistUrl(domain, path) {
        this.http.put('guestlists/' + this.guestlist.id + '/domain-information', {
            'guestlist_domain': this.guestlist_domain,
            'guestlist_path': this.guestlist_path,
        }).then(() => {
            this.studio_url = this._computeStudioUrl(domain, path);
            this.alert.success('Domain saved', 'The domain settings were successfully saved.');
        }, err => {
            this.alert.error('Error', 'Domain information has not been saved. Try again.');
        })
    }

    _loadGuestlistUrl() {
        this.http.get('guestlists/' + this.guestlist.id + '/domain-information', {}).then((response) => {
            this.guestlist_path = response.data.data.guestlist_path;
            this.guestlist_domain = response.data.data.guestlist_domain;
            this.studio_url = this._computeStudioUrl(this.guestlist_domain, this.guestlist_path);
        }, err => {
            this.alert.error('Error', 'Loading domain information failed.');
        })
    }

    _computeStudioUrl(domain, path) {

        if (!domain && !path) {
            return '';
        }

        return 'https://' + domain + (path ? '/' + path : '');
    }

    _initDomainMode() {
        if (this.studioEnabled && this.studioPageAvailable) {
            this.domainMode = 'studio';
            return;
        }

        if (_.get(this.userStore, 'state.company.settings.lp-api.ext_reg_domain')) {
            this.domainMode = 'automated';
            return;
        }

        this.domainMode = 'custom';
    }
}

AlLandingpageGeneralComponentController.$inject = [
    '$scope',
    '$http',
    '$injector',
    'Alert'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/general/controllers/component.js